import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule as ACommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { EmailLinkPipe } from '@tytapp/common/emailLink.pipe';

import { Shell } from './shell';
import { ModelRegistry } from './model-registry';
import { NetworkInformation } from './network-information';
import { Cookies } from './cookies';
import { Base64 } from './base64';
import { Head } from './head';
import { OpenGraph } from './opengraph';
import { UserAgent } from './user-agent';
import { SectionLinkComponent } from './section-link/section-link.component';
import { FormHandler } from './form-handler';
import { FormComponent } from './form/form.component';
import { SoftwareKeyboard } from './software-keyboard';
import { RequestParams } from './request-params';
import { SpinnerComponent } from './spinner/spinner.component';
import { LoadGuardComponent } from './load-guard/load-guard.component';
import { StagingNoteComponent } from './staging-note/staging-note.component';
import { ViewportSize } from './viewport-size';
import { ResponsiveBackgroundPipe } from './responsive-background-pipe';
import { ResponsiveBackgroundImageDirective } from './responsive-background-image.directive';
import { DialogGuard } from './dialog-guard';
import { DateAsUTCDirective } from './date-as-utc.directive';
import { AutolinkPipe } from './autolink.pipe';

import { AppConfig } from './app-config';
import { Redirection } from './redirection';
import { DurationPipe } from './duration.pipe';
import { TrustHtmlPipe } from './trust-html.pipe';
import { MarkdownToHtmlPipe } from './markdown-to-html.pipe';
import { FormSubmitButtonComponent } from './form-submit-button/form-submit-button.component';
import { AsDatePipe } from './as-date.pipe';
import { LoggerService } from './logger.service';
import { Retry } from './retry';

import { Podcast } from 'models';
import { NoticeService } from './notice-service';
import { NoticeComponent } from './notice/notice.component';
import { NewlinesToHtmlPipe } from './newlines-to-html.pipe';
import { SummarizePipe } from './summarize.pipe';
import { LinksToHtmlPipe } from './links-to-html.pipe';
import { ResponsivePictureComponent } from './responsive-picture.component';
import { PageService } from './page-component';
import { PageContextComponent } from './page-context.component';

const COMPONENTS = [
  SectionLinkComponent,
  FormComponent,
  SpinnerComponent,
  LoadGuardComponent,
  StagingNoteComponent,
  ResponsiveBackgroundPipe,
  ResponsiveBackgroundImageDirective,
  DateAsUTCDirective,
  AutolinkPipe,
  DurationPipe,
  AsDatePipe,
  TrustHtmlPipe,
  MarkdownToHtmlPipe,
  NewlinesToHtmlPipe,
  SummarizePipe,
  LinksToHtmlPipe,
  FormSubmitButtonComponent,
  NoticeComponent,
  ResponsivePictureComponent,
  EmailLinkPipe,
  PageContextComponent
];

@NgModule({
  imports: [
    HttpClientModule,
    FormsModule,
    RouterModule,
    ACommonModule
  ],
  declarations: COMPONENTS,
  exports: COMPONENTS
})
export class TYTCommonModule {
  static forRoot(): ModuleWithProviders<TYTCommonModule> {
    return {
        ngModule: TYTCommonModule,
        providers: [
            Shell,
            ModelRegistry,
            NetworkInformation,
            Cookies,
            Base64,
            UserAgent,
            FormHandler,
            SoftwareKeyboard,
            RequestParams,
            OpenGraph,
            Head,
            AppConfig,
            ViewportSize,
            DialogGuard,
            Redirection,
            LoggerService,
            NoticeService,
            Retry,
            PageService
        ]
    };
}
}
